import { render, staticRenderFns } from "./ChbContentDetail.vue?vue&type=template&id=49099e9c&scoped=true"
import script from "./ChbContentDetail.vue?vue&type=script&lang=js"
export * from "./ChbContentDetail.vue?vue&type=script&lang=js"
import style0 from "./ChbContentDetail.vue?vue&type=style&index=0&id=49099e9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49099e9c",
  null
  
)

export default component.exports